var path = 'areas/shared/views/selector/choice.html';
var html = "<div ng-bind-html=\"item.Name | highlight: $select.search\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/choice.html
// module id = 6268688422027535
// module chunks = 1